import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { useRef, useEffect } from 'react';
import Heading from '@components/Heading/Heading';
import Icon from '@components/icons/Icon';
import { ICatalogSectionItemBlock } from '@features/cms/typescript/index';
import styles from '@features/cms/components/pages/CatalogSectionBlocks/CatalogSectionBlocks.styles';
import scrollToElementById from '@utils/scrollToElementById';
import RenderMedia from '@utils/RenderMedia';
type PropsType = {
  item: ICatalogSectionItemBlock;
  layout: string;
  isFirst: boolean;
  getTextColor: () => string;
  getTextHoverColor: () => string;
  getHoverImage: () => string;
  getBgColor: () => string;
  getBgHoverColor: () => string;
};
const CatalogSectionItemTextBgImg = ({
  item,
  layout,
  isFirst,
  getTextColor,
  getTextHoverColor,
  getHoverImage,
  getBgColor,
  getBgHoverColor
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const {
    header,
    image,
    filePath,
    fileTarget,
    video,
    buttonVariant,
    buttonText
  } = item;
  const containerRef = useRef<HTMLDivElement>(null);

  // WCAG 2.4.7 Focus Visible - dodaj klasę na kontenerze gdy link/button ma focus-visible
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const handleFocusIn = (e: FocusEvent) => {
      const target = e.target as HTMLElement;
      if (target.matches('a:focus-visible, button:focus-visible')) {
        container.classList.add('has-focus-visible');
      }
    };
    const handleFocusOut = () => {
      container.classList.remove('has-focus-visible');
    };
    container.addEventListener('focusin', handleFocusIn);
    container.addEventListener('focusout', handleFocusOut);
    return () => {
      container.removeEventListener('focusin', handleFocusIn);
      container.removeEventListener('focusout', handleFocusOut);
    };
  }, []);
  const renderContent = (isLink: boolean) => <>
      {getHoverImage() !== 'none' && <div sx={{
      ...styles.catalogCard(isLink, false, 0, getTextColor(), getBgColor()),
      backgroundImage: getHoverImage()
    }} data-testid="catalog-section-item-text-bg-img" />}
      {filePath && <div sx={styles.styledViewFileLink(getTextHoverColor(), buttonVariant !== 'noIcon')} data-testid="catalog-section-item-text-bg-img-button">
          {buttonVariant !== 'noIcon' && <Icon icon="Download2" />}
          <Heading h={6} headingType={6} whiteSpace="nowrap" color={getTextHoverColor()} uppercase mobile>
            {buttonText || t('download')}
          </Heading>
        </div>}
    </>;
  return <div ref={containerRef} sx={styles.styledLayout(layout, !!image.desktop, 'headingBgImg', getTextColor(), getTextHoverColor(), getBgColor(), getBgHoverColor()).item} data-testid="catalog-section-item-text-bg-img-container">
      <div sx={styles.heading(true)} data-testid="catalog-section-item-text-bg-img-heading">
        <Heading h={isFirst ? 1 : 7} uppercase={false} headingType={7} color={getTextColor()} mobile>
          {header}
        </Heading>
      </div>

      {RenderMedia(image, video, true, undefined, header, false)}
      {filePath ? <>
          {filePath.slice(0, 1) === '#' ? <button type="button" onClick={() => scrollToElementById(filePath.substring(1))} data-testid={`catalogSectionItem-${header}-button`}>
              {renderContent(true)}
            </button> : <Link href={filePath} target={fileTarget || '_blank'} rel={!fileTarget || fileTarget === '_blank' ? 'noopener noreferrer' : ''} data-testid="catalog-section-item-text-bg-img-link">
              {renderContent(true)}
            </Link>}
        </> : <span>{renderContent(false)}</span>}
    </div>;
};
export default CatalogSectionItemTextBgImg;